"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import React, { useContext, useEffect, useEffectEvent, useState } from "react";
import EventReadDetail from "@/app/(main)/(club)/mes-clubs/[id]/components/event-read-detail";
import { getClubEvent, updateEventClubTransition } from "@/app/api/dynabuy-back/api-events";
import Button from "@/components/button";
import ClientFlash from "@/components/global/client-flash";
import ComponentLoading from "@/components/global/component-loading";
import MainTitle from "@/components/global/main-title";
import { flashContext } from "@/context/flash-context";
import { sidebarContext } from "@/context/sidebar-context";
import { EventTransitionEnum } from "@/TS/Enums/global_enums";
import { EventRead } from "@/TS/Interfaces/global_interfaces";
function RestoreEvent(t0) {
  const $ = _c(38);
  const {
    e
  } = t0;
  const [event, setEvent] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [disableButtons, setDisableButtons] = useState(false);
  const {
    setVal
  } = useContext(sidebarContext);
  const {
    applyFlashContext
  } = useContext(flashContext);
  const router = useRouter();
  let t1;
  if ($[0] !== e.clubSlug || $[1] !== e.startDate || $[2] !== e.type || $[3] !== event) {
    t1 = () => {
      if (event) {
        return;
      }
      const handleFetch = async () => {
        setIsLoading(true);
        setEvent(await getClubEvent(e.type, e.clubSlug, e.startDate.split("T")[0]));
        setIsLoading(false);
      };
      handleFetch();
    };
    $[0] = e.clubSlug;
    $[1] = e.startDate;
    $[2] = e.type;
    $[3] = event;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const loadEvent = useEffectEvent(t1);
  let t2;
  if ($[5] !== loadEvent) {
    t2 = () => {
      loadEvent();
    };
    $[5] = loadEvent;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== applyFlashContext || $[9] !== e.clubSlug || $[10] !== e.startDate || $[11] !== e.type || $[12] !== router || $[13] !== setVal) {
    t4 = async () => {
      setDisableButtons(true);
      const res = await updateEventClubTransition(EventTransitionEnum.RESTORE, e.type, e.clubSlug, e.startDate.split("T")[0]);
      if (!res.error) {
        setDisableButtons(false);
        setVal("");
        applyFlashContext({
          message: "La r\xE9union a \xE9t\xE9 r\xE9activ\xE9e avec succ\xE8s !",
          type: "success2"
        }, 18000000);
        router.refresh();
      } else {
        setDisableButtons(false);
        applyFlashContext({
          message: res.message ?? "",
          type: "primary",
          position: "event-restore"
        }, 5000);
      }
    };
    $[8] = applyFlashContext;
    $[9] = e.clubSlug;
    $[10] = e.startDate;
    $[11] = e.type;
    $[12] = router;
    $[13] = setVal;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const handleRestore = t4;
  if (!event) {
    let t5;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <ComponentLoading />;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    return t5;
  }
  let t5;
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MainTitle className="text-center w-full" title={"R\xE9activer ma r\xE9union annul\xE9e"} />;
    t6 = <p className="text-sm italic mb-8 text-center">Vous êtes sur le point de réactiver cette réunion, êtes-vous sûr ?</p>;
    $[16] = t5;
    $[17] = t6;
  } else {
    t5 = $[16];
    t6 = $[17];
  }
  let t7;
  if ($[18] !== event || $[19] !== isLoading) {
    t7 = <EventReadDetail event={event} isLoading={isLoading} />;
    $[18] = event;
    $[19] = isLoading;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ClientFlash path="event-restore" />;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== setVal) {
    t9 = () => setVal("");
    $[22] = setVal;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== disableButtons || $[25] !== t9) {
    t10 = <Button onClick={t9} className="w-full" variant="unfilled" colorTheme="secondary" disabled={disableButtons}>Annuler</Button>;
    $[24] = disableButtons;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== handleRestore) {
    t11 = () => {
      handleRestore();
    };
    $[27] = handleRestore;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== disableButtons || $[30] !== t11) {
    t12 = <Button onClick={t11} className="w-full" variant="filled" disabled={disableButtons}>Réactiver</Button>;
    $[29] = disableButtons;
    $[30] = t11;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t10 || $[33] !== t12) {
    t13 = <div className="flex gap-4 mt-11 px-4">{t10}{t12}</div>;
    $[32] = t10;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t13 || $[36] !== t7) {
    t14 = <div className="flex md:w-3/5 w-full mx-auto flex-col">{t5}{t6}{t7}{t8}{t13}</div>;
    $[35] = t13;
    $[36] = t7;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  return t14;
}
export default RestoreEvent;